var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary"},[_c('div',{staticClass:"right"},[_vm._v(" 应付保费总计 "),_c('strong',[_vm._v("¥"+_vm._s(_vm.amountFormat(_vm.totalAmount)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }